import { Plane } from '@react-three/drei';
import { useAsset } from '@artica/assets';

export default function FogSheet() {
  const video = useAsset('tilescape_snow');
  return (
    <Plane
      args={ [48 * 16 / 9, 48] }
      scale={ 0.25 }
      position={ [0, -84, 0.05] }
      rotation={ [-Math.PI / 2, 0, 0] }
    >
      <meshLambertMaterial
        alphaMap={ video }
        emissive={ [1, 1, 1] }
        emissiveMap={ video }
        emissiveIntensity={ 5 }
        transparent
      />
    </Plane>
  );
};